"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NUMBER_OF_LOG_ENTRIES_EXPORT_LIMIT = void 0;
// Protect ourselves from exceeding time and memory to query all the data
//  by setting a limit on number of EDP Log entries that could be exported at a time.
// Shared here for FE & BE validation to stay aligned
var NUMBER_OF_LOG_ENTRIES_EXPORT_LIMIT = 10000;
exports.NUMBER_OF_LOG_ENTRIES_EXPORT_LIMIT = NUMBER_OF_LOG_ENTRIES_EXPORT_LIMIT;